import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './modules/login'
import User from './modules/user'
import Repay from './modules/repay'
import Loan from './modules/loan'
import { $eventTrack } from '@/plugins/eventTrack'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    redirect: localStorage.getItem('x-auth-token') ? '/home' : '/refuseRegisterPage'
  },
  {
    path: '/base',
    name: 'Base',
    component: () => import('@/views/verify/base.vue'),
    meta: { pageName: 'VerifyBase-refused' }
  },
  {
    path: '/facial',
    name: 'Facial',
    component: () => import('@/views/verify/facial.vue'),
    meta: { pageName: 'VerifyFacial-refused' }
  },
  {
    path: '/loanSuccess',
    name: 'LoanSuccess',
    component: () => import('@/views/loan/loanSuccess.vue'),
    meta: { pageName: 'LoanSuccess-refused' }
  },
  {
    path: '/inReview',
    name: 'InReview',
    component: () => import('@/views/loan/inReview.vue'),
    meta: { pageName: 'InReview-refused' }
  },
  {
    path: '/scrrenGuide',
    name: 'ScrrenGuide',
    component: () => import('@/views/scrrenGuide.vue'),
    meta: { pageName: 'ScrrenGuide-refused' }
  },
  {
    path: '/photoLiving',
    name: 'PhotoLiving',
    component: () => import('@/views/verify/components/photoLiving.vue'),
    meta: { pageName: 'VerifyFacialLiving-refused' }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import('@/views/protocol.vue')
  }
]
routes = routes.concat(Login).concat(User).concat(Loan).concat(Repay)
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.name) return next('/home')
  if (to.name === 'RefuseRegisterPage' || to.name === 'ScrrenGuide' || to.name === 'Protocol') {
    return next()
  }
  if (!localStorage.getItem('x-auth-token') && !localStorage.getItem('userId')) {
    return next('/refuseRegisterPage')
  }
  next()
})

router.afterEach((to, from) => {
  if (to.meta.pageName) {
    $eventTrack({
      pageName: to.meta.pageName,
      action: 'Enter'
    })
  }
})
export default router
